var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _vm.question.questionTypeId == _vm.types.TextoAbierto
      ? _c(
          "div",
          [
            _c("label", { staticClass: "label", attrs: { for: "areafield" } }, [
              _vm._v(
                " " + _vm._s(_vm.question.additionalQuestionDescription) + " "
              )
            ]),
            _c("validation-provider", {
              attrs: {
                name: `section-complete-${_vm.question.sectionId}-question-${_vm.question.additionalQuestionId}`,
                rules: "required"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-text-area", {
                          attrs: {
                            id: `comment-${_vm.question.additionalQuestionId}`,
                            "count-classes": ["d-block text-right"],
                            "custom-error-msg": _vm.customErrorMsg(
                              _vm.question.additionalQuestionDescription
                            ),
                            disabled: _vm.readOnly,
                            error: errors[0],
                            maxlength: 3000,
                            name: "areafield",
                            "show-char-count": ""
                          },
                          on: { input: _vm.emitTouched },
                          model: {
                            value: _vm.value,
                            callback: function($$v) {
                              _vm.value = $$v
                            },
                            expression: "value"
                          }
                        })
                      ]
                    }
                  }
                ],
                null,
                false,
                2362569379
              )
            })
          ],
          1
        )
      : _vm.question.questionTypeId == _vm.types.VoF
      ? _c(
          "div",
          [
            _c("label", { staticClass: "label", attrs: { for: "eqType" } }, [
              _vm._v(
                " " + _vm._s(_vm.question.additionalQuestionDescription) + " "
              )
            ]),
            _c("validation-provider", {
              attrs: {
                name: `section-complete-${_vm.question.sectionId}-question-radio-${_vm.question.additionalQuestionId}`,
                rules: "required"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-radio", {
                        attrs: {
                          "change-event": _vm.onSelectedAnswers,
                          "custom-error-msg": "Favor seleccione",
                          disabled: _vm.readOnly,
                          error: Boolean(errors[0]),
                          "is-inline": "",
                          name: "penaltyOptions",
                          options: _vm.defaultOptions
                        },
                        model: {
                          value: _vm.value,
                          callback: function($$v) {
                            _vm.value = $$v
                          },
                          expression: "value"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }